import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { UserDetailInterface } from '@interfaces/user-detail.interface';
import { MatDialog } from '@angular/material';
import { EditAdminDialogComponent } from '@modules/super-admin/components/edit-admin-dialog/edit-admin-dialog.component';
import * as adminReducer from '@modules/super-admin/reducers';
import { ConfirmDialogComponent } from '@modules/shared/components/confirm-dialog/confirm-dialog.component';
import { Subscription } from 'rxjs';
import { GetAllUsers } from '@modules/super-admin/actions/users.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDetailService } from '@modules/super-admin/services/user-detail.service';
import _ from 'lodash';
import { MessengerService } from '@modules/messenger/messenger.service';
@Component({
  selector: 'edex-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  displayedColumns: string[] = ['contactName', 'email', 'phoneNumberCall',];
  dataSource = new MatTableDataSource<UserDetailInterface>([]);
  merchantStatusOptions = [
    { label: 'All', value: '' },
    { label: 'Web applications', value: 'web' },
    { label: 'Information upload stage', value: 'upload' },
    { label: 'Being assessed', value: 'assessed' },
    { label: 'Approved', value: 'approved' },
    { label: 'Website/POS integration Stage', value: 'integration' },
    { label: 'Live and Processing', value: 'processing' },
  ];

  userStatus = '';
  search = '';
  debouncedFilter;

  private merchantsSub: Subscription;
  public users$ = this.store.pipe(select(adminReducer.getUsers));

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private store: Store<adminReducer.State>,
    private router: Router,
    private msgr: MessengerService,
    private route: ActivatedRoute,
    private userApiService: UserDetailService,
    public dialog: MatDialog,
  ) {
    this.debouncedFilter = _.debounce(this.applyFilter.bind(this), 500);
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((query) => {
      this.userStatus = query.get('status') || '';
      this.search = query.get('search') || '';
      this.getUsers();
    });
  }

  getUsers() {
    this.userApiService.getUserDetail({
      status: this.userStatus,
      search: this.search,
      isDeleted: false,
    }).subscribe(
      (users) => {
        this.dataSource = new MatTableDataSource<UserDetailInterface>(users);
        this.dataSource.paginator = this.paginator;
      },
      (err) => {

      }
    );
  }

  deactivateMerchant(event: Event, merchant: UserDetailInterface) {
    event.stopPropagation();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        text: 'Are you sure to deactivate this merchant?'
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // this.merchantApiService.deactivateMerchant({
        //   id: merchant._id,
        // }).subscribe(
        //   (data) => {
        //     this.getMerchants()
        //     this.msgr.message('User account deactivate')
        //   },
        //   (err) => {
        //     this.msgr.error('Something went wrong...');
        //   }
        // );
      }
    });
  }


  applyFilter() {
    this.router.navigate(['/admin/users/merchants'], {
      queryParams: {
        status: this.userStatus,
        search: this.search,
      },
    }).then();
  }

  ngOnDestroy() {
    if (this.merchantsSub) {
      this.merchantsSub.unsubscribe();
    }
  }

}
